module.exports = __webpack_public_path__ + "img/36_10.d85b5eef.png";